// There are instances form errors return nobject instead of array. Maybe Symfony's bug
// or the serializer bug. This usually happen on form collections only.
export function adjustFormError(formErrors) {
  if (formErrors.constructor !== Array) {
    let arrayErrors = [];
    Object.keys(formErrors).forEach((key) => {
      arrayErrors[key] = formErrors[key];
    });

    return arrayErrors;
  }

  return formErrors;
}



// WEBPACK FOOTER //
// ./client/app/shared/utils/form.utils.js